import React, { useEffect, useState } from 'react'
import { Link } from "react-router-dom";
import "../../styles/matchStatsFirstHalfCard.css";

export default function MatchStatsFirstHalfCard({ stats }) {
    const [isOpen, setIsOpen] = useState(true);
    const [isLoggedIn, setIsLoggedIn] = useState(null);

    useEffect(() => {
        fetch("https://focifanatik.hu/api/session_check.php", {
            credentials: "include"
        })
            .then(res => res.json())
            .then(data => {
                if (!data.loggedIn) {
                    setIsLoggedIn(false);
                }
                else if (data.loggedIn) {
                    setIsLoggedIn(true);
                }
            });
    }, []);


    return (
        <div className='firsthalf-stats-card'>

            <div className="ms-stat-firsthalf-title" onClick={() => setIsOpen(!isOpen)}>
                Első félidei statisztikák
            </div>


            {isOpen && (

                isLoggedIn ? (<>
                    <div className="stat-card-border">
                        {/* LOGÓK */}
                        <div className="ms-stat-firsthalf-logos">
                            <img src={`/images/teams/${stats.teams.home.logo}`} alt={stats.teams.home.name} />
                            <span>VS</span>
                            <img src={`/images/teams/${stats.teams.away.logo}`} alt={stats.teams.away.name} />
                        </div>

                        {/* STAT SOROK */}
                        <div className="ms-stat-firsthalf-list">
                            {stats.firstHalf.map((stat) => {
                                const homeBetter = stat.home_value > stat.away_value;
                                const awayBetter = stat.away_value > stat.home_value;

                                return (
                                    <div className="ms-stat-firsthalf-row" key={stat.stat_key}>

                                        <span className={`ms-value ${homeBetter ? "better" : ""}`}>
                                            {stat.unit === "%"
                                                ? Math.trunc(stat.home_value) + stat.unit
                                                : stat.home_value + stat.unit
                                            }
                                        </span>

                                        <span className="ms-label">
                                            {stat.label}
                                        </span>

                                        <span className={`ms-value ${awayBetter ? "better" : ""}`}>
                                            {stat.unit === "%"
                                                ? Math.trunc(stat.away_value) + stat.unit
                                                : stat.away_value + stat.unit
                                            }
                                        </span>

                                    </div>
                                );
                            })}
                        </div>
                    </div>
                </>
                ) : (
                        <div className="stats-locked-card">

                            <div className="lock-icon">
                                🔒
                            </div>

                            <h3>Részletes statisztikák</h3>

                            <p>
                                Jelentkezz be vagy regisztrálj a teljes statisztikák
                                megtekintéséhez.
                            </p>

                            <div className="stats-lock-buttons">
                                <Link to="/bejelentkezes"><button className="login-btn">Bejelentkezés</button></Link>
                                <Link to="/regisztracio"><button className="register-btn">Regisztráció</button></Link>

                            </div>

                        </div>
                )

            )
            }

        </div >
    )
}
